export default __webpack_public_path__ + "static/media/rgp_pvh_nca_almati.c24beeae.png";